import { memo } from 'react';

import { buildRootUrl } from '@/common/app/utils/urlsUtils';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';

const CartPageMeta = () => {
    const title = 'Shopping Cart - TripShock!';
    const description = '';
    const canonical = buildRootUrl('cart');

    return (
        <CommonMeta
            title={title}
            description={description}
            imageSrc={''}
            slug={buildRootUrl()}
            canonical={canonical}
            structuredData={[]}
            ogUrl={canonical}
        />
    );
};

export default memo(CartPageMeta);
